import { createInstance } from './request/index'

export const request = createInstance()

export default request.instance
